import tinycolor from 'tinycolor2';

const tintSteps = {
    50: 90,
    100: 70,
    200: 50,
    300: 30,
    400: 10,
};

const shadeSteps = {
    600: 10,
    700: 30,
    800: 50,
    900: 70,
    950: 90,
};

export function generateColorVariables(colorByType?: {
    primary: string;
    secondary: string;
    base: string;
    info: string;
    success: string;
    warning: string;
    error: string;
}) {
    if (!colorByType) {
        return;
    }

    const colorVariables: string[] = [];

    Object.entries(colorByType).forEach(([type, color]) => {
        Object.entries(tintSteps).forEach(([step, percent]) => {
            const tintColor = tinycolor.mix(color, '#ffffff', percent).toHexString();
            colorVariables.push(`--tw-color-${type}-${step}: ${tintColor};`);
        });

        colorVariables.push(`--tw-color-${type}-500: ${color};`);

        Object.entries(shadeSteps).forEach(([step, percent]) => {
            const shadeColor = tinycolor.mix(color, '#000000', percent).toHexString();
            colorVariables.push(`--tw-color-${type}-${step}: ${shadeColor};`);
        });
    });

    return colorVariables.join('\n');
}

type ColorGroup = 'primary' | 'secondary' | 'base' | 'info' | 'success' | 'warning' | 'error';
const colorGroups: ColorGroup[] = ['primary', 'secondary', 'base', 'info', 'success', 'warning', 'error'];
const colorShades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950] as const;

export function generateTailwindColorsConfig(): Record<ColorGroup, Record<number, string>> {
    return colorGroups.reduce((acc, group) => {
        acc[group] = colorShades.reduce((shadeAcc, shade) => {
            shadeAcc[shade] = `var(--tw-color-${group}-${shade})`;
            return shadeAcc;
        }, {} as Record<number, string>);
        return acc;
    }, {} as Record<ColorGroup, Record<number, string>>);
}
